import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface LoadingState {
  referenceNo: string,
  policyNo: string,
  isCompleted: boolean;
  cardHolderName: string,
  bankId: number,
  otherBank: string
}

const initialState: LoadingState = {
  referenceNo: '',
  policyNo: '',
  isCompleted: false,
  cardHolderName: '',
  bankId: 0,
  otherBank: ''
}

const step5Slice = createSlice({
  name: 'DPI-Step5',
  initialState,
  reducers: {
    updateReferenceNo: (state, action: PayloadAction<string>) => {
      state.referenceNo = action.payload;
    },
    updatePolicyNo: (state, action: PayloadAction<string>) => {
      state.policyNo = action.payload;
    },
    completeStep: (state, action: PayloadAction<boolean>) => {
      state.isCompleted = action.payload;
    },
    updateCardHolderName: (state, action: PayloadAction<string>) => {
      state.cardHolderName = action.payload;
    },
    updateBankId: (state, action: PayloadAction<number>) => {
      state.bankId = action.payload;
    },
    updateOtherBank: (state, action: PayloadAction<string>) => {
      state.otherBank = action.payload;
    },
  },
  extraReducers: {}
})

export const { updateReferenceNo, updatePolicyNo, updateCardHolderName, updateBankId, updateOtherBank, completeStep } = step5Slice.actions;

export default step5Slice.reducer;